import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Note from 'components/Note';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { NotesContainer, NavigatorContainer, Navigator } from './styles';

const BookingList = ({ bookings, type, buttonTitle="Manage booking", padButtonTitle="Manage", mobileButtonTitle="Manage" }) => {
  
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1)
  const pageSize = 4
  const pageCount = Math.ceil(bookings?.length/pageSize)

  useEffect(() => {
    setPageNumber(1)
  }, [bookings])

  const paginate = (array, page_size, page_number) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array?.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  return (
    <Card>
      <CardHeader>
        <div className="type">{type}</div>
      </CardHeader>
      {bookings?.length > pageSize ? (
        <NavigatorContainer>
          <Navigator
            disabled={pageNumber <= 1}
            onClick={previousPage}
          >
            {"<"} Back
          </Navigator>
          <Navigator
            disabled={pageNumber >= pageCount}
            onClick={nextPage}
          >
            Next {">"}
          </Navigator>
        </NavigatorContainer>
      ) : null}
      <NotesContainer>
        {bookings.length ? (
          (paginate(bookings, pageSize, pageNumber) || []).map((booking, index) => {
            const { bookingId, checkInDate, checkOutDate, fullName } = booking;
            return (
              <Note
                key={bookingId}
                description={
                  fullName +
                  " " +
                  moment(checkInDate).tz(TIME_ZONE).format("MMM Do YYYY") +
                  " - " +
                  moment(checkOutDate).tz(TIME_ZONE).format("MMM Do YYYY")
                }
                disabled
                buttonTitle={buttonTitle}
                padButtonTitle={padButtonTitle}
                mobileButtonTitle={mobileButtonTitle}
                onClickButton={(event) => {
                  if (event.metaKey || event.ctrlKey) {
                    // Open new tab with absolute URL
                    window.open(`https://pms.rookhotel.com/booking-details/${booking.group?.groupId}`, "_blank")
                  } else {
                    // Normal navigation
                    navigate(`/booking-details/${booking.group?.groupId}`)
                  }
                }}
              />
            );
          })
        ) : (
          <Note description="No booking yet" disabled />
        )}
      </NotesContainer>
    </Card>
  );
};

export default BookingList;
